// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"707eac65","796":"81377f7c"}[chunkId] + ".chunk.js";
};